addEventListener("DOMContentLoaded", _=> {
    headerCurtain.addEventListener("click", _=> cartIcon.checked = false);
    let breaker = parseInt(FN.getCSSVar(document.body, "--break-md-end"));
    let breaker2 = parseInt(FN.getCSSVar(document.body, "--break-lg-end"));
    ID.cartIcon.onclick = e => {
        let anchor = document.querySelector(".navmenu-cart");
        let snippet = cart.parentNode;
        if(document.body.offsetWidth <= breaker2) {
        /* odkomentovat pro mobilní dialog
            snippet.style.width = "100%";
            snippet.style.left = 0;
            snippet.style.margin = 0;
        */
            e.preventDefault();
            location.href = ID.cart.querySelector(".footer .button.secondary").href;
        }
        else {
            snippet.style.top = (anchor.offsetTop + 48) + "px";
            snippet.style.width = "550px";
            snippet.style.left = (anchor.offsetLeft - 550 + 48) + "px"; // 48 = šířka ikony
            snippet.style.removeProperty("margin");
        }
    }
});